import { ReactNode, forwardRef } from "react"
import { Spin } from "antd"
export const Title = forwardRef((p: { children: ReactNode }, ref: any) => {
    return (
        <strong ref={ref} style={{
            display: 'block', padding: '4px',
            color: 'rgb(64, 240, 255)',
            background: 'linear-gradient(90deg, rgb(3, 103, 174) 0%, rgba(3, 102, 174, 0) 100%)'
        }}>{p.children}</strong>
    )
})


export const Loading = () => {
    return <Spin style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }} spinning></Spin>
}